import React, { useState, useEffect } from "react";
import axios from "axios";
import { Trophy } from "lucide-react";
import { API } from "@/config";

export default function ChampionshipsPage() {
  const [championships, setChampionships] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchChampionships();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- mount-only fetch

  const fetchChampionships = async () => {
    try {
      const res = await axios.get(`${API}/championships`);
      setChampionships(res.data);
    } catch (err) {
      console.error("Error fetching championships:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="championships-page">
      <section className="championships-hero">
        <div className="championships-hero-content">
          <Trophy size={64} className="championships-trophy-icon" />
          <h1>8 National Championships</h1>
          <p>The most storied program in college basketball history</p>
        </div>
      </section>

      <section className="container" style={{ padding: '3rem 1rem 4rem' }}>
        <div className="championships-grid">
          {championships.map((champ) => (
            <div key={champ.year} className="championship-card">
              <div className="championship-year-badge">
                <Trophy size={20} />
                <span>{champ.year}</span>
              </div>
              <div className="championship-details">
                <h2>Kentucky vs {champ.opponent}</h2>
                <p className="championship-score">{champ.score}</p>
                <p className="championship-location">{champ.location}</p>
                <p className="championship-coach">Coach: {champ.coach}</p>
                <div className="championship-players">
                  <strong>Key Players:</strong>
                  <p>{champ.key_players.join(", ")}</p>
                </div>
                <p className="championship-description">{champ.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
